import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { TxSet } from 'src/model/set.model';
import { TransactionSubType } from 'src/model/transactionSubType.model';
import { ReceiptDetailsComponent } from '../receipt-details/receipt-details.component';

@Component({
    selector: 'app-receipt-sets-listview',
    templateUrl: './receipt-sets-listview.component.html',
    styleUrls: ['./receipt-sets-listview.component.scss'],
    standalone: false
})
export class ReceiptSetsListviewComponent implements OnInit, OnChanges {
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);


  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<TxSet>([]);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input() setList: TxSet[];
  @Input() expenseSubtypeList: TransactionSubType[];
  @Input() dlSubtypeList: TransactionSubType[];

  @Output() passEntry = new EventEmitter<any>();

  ngOnInit(): void {
    this.displayedColumns = ['CompanyCode', 'ID', 'Name', 'Remark', 'SetRemark', 'Status', 'Total', 'Transactions'];
    // this.dataSource.data = this.setList;
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataSource.data = this.setList
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  calculateTotal(set: TxSet) {
    return set.TransactionList.reduce((sum, current) => sum + current.Amount, 0);
  }

  openSetDetails(set: TxSet) {
    const modalRef = this.sharedService.openModal(ReceiptDetailsComponent, "regularModal");
    modalRef.componentInstance.receipt = set;
    modalRef.componentInstance.isModal = true;
    modalRef.componentInstance.expenseSubtypeList = this.expenseSubtypeList;
    modalRef.componentInstance.dlSubtypeList = this.dlSubtypeList;
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      if (typeof entry === 'boolean')
        this.passEntry.emit(entry);
      else
        this.dataSource.data = this.dataSource.data.map(d => d.ID === set.ID ? entry : d);
    });
  }

  trackById(index: number, item: any): any {
    return item.ID;
  }

}
